import React, { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import { Card } from "react-bootstrap";
import { useDispatch, useSelector } from 'react-redux';
import { getCustomer, getNotificationDetails,setNotificationWithRemark,clearCustomerDetails,fetchDataEvent } from './stateManegement/dispatch';
import { useForm } from 'react-hook-form';
export default function NotificationRequestInput({userData}) {
  const { loading, customerData, apierror,customerTableData,eventData } = useSelector((state) => state.connectionReducer);
  const dispatch = useDispatch();
  const [isDisconnectAction, setIsDisconnectAction] = useState(false);
  const [isCusmerNum, setisCusmerNum] = useState(false);
  const [customerNumber, setcustomerNumber] = useState('');
  const [remark, setRemark] = useState('');
  const [hideDataTable, setHideDataTable] = useState(true)

  // Using react-hook-form
  const { register, handleSubmit, setValue, reset,formState: { errors }, } = useForm();


  const handleRemark = (e) =>{
    setRemark(e.target.value)
    if(e.target.value.length < 0){
      setIsDisconnectAction(true)
    }else{
      setIsDisconnectAction(false)
    }
   
  }
  const handleInputChange = (e) => {
    const consumerNum = e.target.value;
    setcustomerNumber(consumerNum);
    if(e.target.value.length < 0){
      setisCusmerNum(true)
    }else{
      setisCusmerNum(false)
    }
   
    if (consumerNum.length > 4) { 
      // Use setTimeout to delay the dispatch
      setTimeout(() => {
        dispatch(getCustomer(userData, consumerNum));
      }, 1000); // 1000 milliseconds delay (1 second)
    }
  };

  const handleSubmitForm = (data) => {
    if(data.customerNumber.length === 0){
      setisCusmerNum(true)
      window.scrollTo({
        top: 0,
        behavior: 'smooth' // Optional for smooth scrolling
      });
      // Add your submit logic here (e.g., send data to an API)
    }else{
      dispatch(getNotificationDetails(userData, data))
      .then(() => {
     
        setHideDataTable(false)
        //  window.alert("Cusomer details get successfully!");
      })
      .catch((error) => {
        console.error("An error occurred:", error);
      });
    }
   
  };
  useEffect(() => {
    dispatch(fetchDataEvent(userData));
    
  }, [dispatch]);
  const handleDisconnect = (data) => {
    if(data.remark.length === 0){
      setIsDisconnectAction(true)
    }else{
      dispatch(setNotificationWithRemark(userData, data))
      .then(() => {
        window.alert("Notification submitted successfully!");
        reset(()=>{
          dispatch(clearCustomerDetails(userData));
          setcustomerNumber("");
          setRemark('');
        }); 
    

      })
      .catch((error) => {
        console.error("An error occurred:", error);
      });
    }
   
    
  };

  
  useEffect(() => {
    // Initialize form values if needed)
    setValue("meterId", customerData?.pDATASET?.[0]?.METER_ID || '');
    setValue("customerNumber", customerNumber);
    setValue("customerId",customerData?.pDATASET?.[0]?.CUSTOMER_ID || "")
    setValue("customer_name",customerData?.pDATASET?.[0]?.CUSTOMER_NAME || "")
    setValue("meterNumber",customerData?.pDATASET?.[0]?.METER_NO || "")
    setValue("eventName",1)

  }, [customerData, customerNumber, setValue]);



 

  return (
    <>
      <Card style={{ height: "auto", width: "100%", backgroundColor: "#17234D", borderRadius: "0px" }}>
        <Card.Body>
          <Card.Title style={{ color: "#fff", fontFamily: "Roboto-Regular", fontSize: "25px" }}>
            Notification Request Input
          </Card.Title>
        </Card.Body>
      </Card>
      <Card style={{ boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)", margin: "30px" }}>
        <Card.Body style={{ maxHeight: "65vh", overflowY: "auto", paddingBottom: "5%" }}>
          <Form onSubmit={handleSubmit(handleSubmitForm)}>
            <Card style={{ borderWidth: 0, height: '60px', width: '100%', backgroundColor: '#FFF6D6', borderRadius: '0px' }}>
              <Container style={{ paddingTop: '10px' }}>
                <Row>
                  <Col sm={2} style={{ fontFamily: "Roboto-Light", fontSize: '13px' }}>State</Col>
                  <Col sm={2} style={{ fontFamily: "Roboto-Light", fontSize: '13px' }}>District</Col>
                </Row>
                <Row>
                  <Col sm={2} style={{ fontFamily: "Roboto-Regular ", fontSize: '15px' }}>
                    <input className="inputHide" defaultValue={userData.pDATASET[0].STATE_NAME} />
                  </Col>
                  <Col sm={2} style={{ fontFamily: "Roboto-Regular", fontSize: '15px' }}>
                    <input className="inputHide" defaultValue={userData.pDATASET[0].CIRCLE_NAME} />
                  </Col>
                </Row>
              </Container>
            </Card>

            <Row className="mb-3">
              <Col sm={4}>
                <Form.Group className="mb-3">
                  <Form.Label><span className="req">*</span>Consumer no :{" "}</Form.Label>
                  <Form.Control
                    {...register("customerNumber")} // Register the input with react-hook-form
                    value={customerNumber}
                    onChange={handleInputChange}
                    type="text"
                    placeholder="Consumer no"
                   
                  />
                   {/* errors will return when field validation fails  */}
                   {isCusmerNum && (
                    <span style={{ color: "red" }}>This field required</span>
                  )}
                </Form.Group>
              </Col>
              <Col sm={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Customer Id : </Form.Label>
                  <Form.Control
                    type="text"
                    value={customerData?.pDATASET?.[0]?.CUSTOMER_ID || ""}
                    placeholder="Consumer Id"
                    disabled={true}
                  />
                </Form.Group>
              </Col>
              <Col sm={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Customer Name: </Form.Label>
                  <Form.Control
                    type="text"
                    value={customerData?.pDATASET?.[0]?.CUSTOMER_NAME || ""}
                    placeholder="Consumer name"
                    disabled={true}
                  />
                </Form.Group>
              </Col>
            </Row>

            <hr />           
            <Row className="mb-3" >
            
              <Col sm={4}>
                <Form.Group>
                  <Form.Label>Meter No</Form.Label>
                  <Form.Select  disabled={customerData?.pDATASET?.length >= 0 ? false : true } aria-label="Default select example">
                  {customerData?.pDATASET?.map((item, index) => (
                    <option className="tableOption" key={index} value={item.METER_NO || ""}>
                      {item.METER_NO || ""}
                    </option>
                  ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col sm={4}>
                <Form.Group className="mb-3" controlId="formGroupEmail">
                  <Form.Label>Meter Id</Form.Label>
                  <Form.Control
                    type="text"
                    disabled={true}
                    value={customerData?.pDATASET?.[0]?.METER_ID || ''}
                  />
                </Form.Group>
              </Col>
              <Col >
                    <Form.Group>
                      <Form.Label><span className="req">*</span>Event Type</Form.Label>
                      <Form.Select  aria-label="Default select example" {...register("eventName")}>
                      <option value=''>Select an option</option>
                            {eventData?.pDATASET?.map(service => (
                              <option key={service.EVENT_TYPE_ID} value={service.EVENT_TYPE_ID}>
                                {service.EVENT_NAME}
                              </option>
                            ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
            </Row>

            <hr />
           
            <div className="btn_div">
            <button className="btn btn-primary" type="button" onClick={() => { reset(()=>{
              dispatch(clearCustomerDetails(userData))
              setcustomerNumber("")
              setRemark('')
            }); }}>
              Clear All
            </button>
              <input className="btn btn-primary" type="submit" value="SUBMIT" />
            </div>
          </Form>
          <hr />
          <>
          
          <div className={hideDataTable  ? "d-none" : ""}>
          {hideDataTable ? <div style={{ textAlign: 'center', fontSize: '15px' }}>No Records Found!!</div> : null}
          {customerTableData === undefined ? <div style={{ textAlign: 'center', fontSize: '15px' }}>No Records Found!!</div> : null}
          <table border="1" className={customerTableData?.pDATASET === undefined && 0 ? "d-none" : ""}>
            <thead>
            <tr>
       
                <th style={{ backgroundColor: "#FFF6D6" }} width="200">EVENT DATA</th>
                <th style={{ backgroundColor: "#FFF6D6" }} width="200">EVENT TYPE</th>
                <th style={{ backgroundColor: "#FFF6D6" }} width="200">DEVICES STATUS</th>
                <th style={{ backgroundColor: "#FFF6D6" }} width="200">CURRENT BALANCE</th>
                <th style={{ backgroundColor: "#FFF6D6" }} width="200">ACTION STATUS</th>
                <th style={{ backgroundColor: "#FFF6D6" }} width="200">REMARKS</th>
                <th style={{ backgroundColor: "#FFF6D6" }} width="200">TARIFF ID</th>
              </tr>
            </thead>
            <tbody>
            {customerTableData?.pDATASET?.map((item, index) => (
                <tr key={index}>
                  <td>{item.EVENT_DATE}</td> {/* Example Remarks */}
                  <td>{item.EVENT_NAME}</td> {/* Example Event DateTime */}
                  <td>{item.DEVICE_STATUS}</td> {/* Example Event DateTime */}
                  <td>{item.CURRENT_BALANCE_VALUE}</td> {/* Example Event DateTime */}
                  <td>{item.ACTION_STATUS}</td> {/* Example Event DateTime */}
                  <td>{item?.REMARKS || "No Comment"}</td> {/* Example Event DateTime */}
                  <td>{item.TARIFF_ID}</td> {/* Example Event DateTime */}
                </tr>
              ))}
            </tbody>
          </table>
          <hr />
            
            </div> 
      
            <Form onSubmit={handleSubmit(handleDisconnect)}>
              <Row className="mb-3">
                <Col sm={4}>
                  <Form.Group className="mb-3">
                    <Form.Label><span className="req">*</span>Notification Remarks :{" "}</Form.Label>
                    <Form.Control type="text" placeholder="Remarks"   
                    {...register("remark")} 
                    value={remark}
                    onChange={handleRemark}
                    />
                  </Form.Group>
                  {isDisconnectAction && (
                    <span style={{ color: "red" }}>This field required</span>
                  )}
                </Col>
                <Col sm={4}>
                  <div style={{ marginTop: 30, marginLeft: "10px" }}>
                    <Button variant="primary" onClick={handleSubmit(handleDisconnect)}>Notify</Button>
                  </div>
                </Col>
              </Row>
            </Form>
          </>
        </Card.Body>
      </Card>
    </>
  );
}
